import { FC } from "react";
import { IconProps } from "./types";

export const XMarkThin: FC<IconProps & { dataAutomationId?: string }> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  dataAutomationId,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    data-automation-id={dataAutomationId}
    {...props}
  >
    <path
      d="M4.31107 5.22315L19.3464 20.2311L20.2861 19.2931L5.25078 4.28516L4.31107 5.22315Z"
      fill={fill}
    />
    <path
      d="M19.3215 4.33925L4.28613 19.3472L5.22584 20.2852L20.2612 5.27724L19.3215 4.33925Z"
      fill={fill}
    />
  </svg>
);
